import React from 'react';
import { motion } from 'framer-motion';

const GoldCrown = () => {
  return (
    <motion.div
      initial={{ scale: 0, rotate: -45, opacity: 0 }}
      animate={{ scale: 1, rotate: 0, opacity: 1 }}
      whileHover={{ 
        scale: 1.15, 
        rotate: [0, -10, 10, -10, 0],
        filter: "drop-shadow(0px 0px 8px rgba(255, 215, 0, 0.8))"
      }}
      transition={{ 
        type: "spring", 
        stiffness: 260, 
        damping: 20 
      }}
      style={{ 
        display: 'inline-flex', 
        alignItems: 'center', 
        marginLeft: '8px', 
        cursor: 'pointer' 
      }}
      title="Gold Creator"
    >
      <svg 
        width="28" 
        height="28" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Glavni deo krune */}
        <path 
          d="M5 16L3 5L8.5 10L12 2L15.5 10L21 5L19 16H5Z" 
          fill="url(#gold-gradient)" 
          stroke="#B8860B" 
          strokeWidth="0.5" 
          strokeLinejoin="round"
        />
        {/* Baza krune */}
        <path 
          d="M5 18H19V20H5V18Z" 
          fill="url(#gold-gradient)" 
        />
        <defs>
          <linearGradient id="gold-gradient" x1="12" y1="2" x2="12" y2="20" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FFE55C" />
            <stop offset="0.4" stopColor="#FFD700" />
            <stop offset="0.8" stopColor="#DAA520" />
            <stop offset="1" stopColor="#B8860B" />
          </linearGradient>
        </defs>
      </svg>
    </motion.div>
  );
};

export default GoldCrown;